import { track } from 'ripple';
import { LandingPage } from './LandingPage.ripple';
import { AuthPage } from './AuthPage.ripple';
import { DashboardPage } from './DashboardPage.ripple';

export component App() {
	let currentPage = track('landing'); // 'landing', 'auth', 'dashboard'

	switch (@currentPage) {
		case 'landing':
			<LandingPage
				onAuth={() => @currentPage = 'auth'}
				onDashboard={() => @currentPage = 'dashboard'}
			/>
			break;
		case 'auth':
			<AuthPage
				onBack={() => @currentPage = 'landing'}
				onDashboard={() => @currentPage = 'dashboard'}
			/>
			break;
		case 'dashboard':
			<DashboardPage
				onBack={() => @currentPage = 'landing'}
			/>
			break;
	}

	<style>
		.app {
			width: 100%;
			min-height: 100vh;
		}
	</style>
}